import React, { Component } from 'react'
import './index.less'
interface GoodsTitleProps {
  className?: string
  count: number
}
export default class GoodsTitle extends Component<GoodsTitleProps> {
  render() {
    return (
      <div className='goods-title-content'>
        <div className='goods-title-left'>
          <img className='goods-logo' src='/public/assets/img/shopping_cart_logo.png' alt="" />
          <span className='goods-title'>安歆公寓</span>
        </div>

        <span className='goods-count'>{this.props.count}件</span>
      </div>
    )
  }
}
